module.exports = __webpack_public_path__ + "static/MAI_DataReports_02-f629e857834b34fb94d78f4944ec5805.png";